import React, { PropTypes } from 'react';
import Persons from '../Persons';

const Producers = ({ store, relay }) => (
    <Persons persons={store.allProducers.edges} relay={relay} type="Producers" />
);

Producers.propTypes = {
    store: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
};

export default Producers;


// WEBPACK FOOTER //
// ./app/components/Person/Producers/Producers.jsx